import {
  CreateFieldInput,
  CreateFieldTextarea,
  CreateFormActions,
  CreateNextSteps,
  PageTitle
} from '../../components.js';
import { Page } from '../base.js';

export class SurveysCreate extends Page {
  static nextSteps = [
    { icon: 'form', label: 'Add survey questions' },
    { icon: 'settings', label: 'Configure the response flow' },
    { icon: 'link', label: 'Share the survey' },
    { icon: 'chart', label: 'Review responses' }
  ];

  static timlComponents = {
    CreateFieldInput,
    CreateFieldTextarea,
    CreateFormActions,
    CreateNextSteps,
    PageTitle
  };

  static get formAction() {
    return API.resourceUrl('surveys');
  }

  static timl = `
    .auth-create-page.surveys-create-page
      <PageTitle title="Create Survey">
      .auth-create-content
        p.auth-create-description Create a survey to gather feedback and guide users through questions.
        .create-page-grid
          form.create-form-card[method="POST" action="{{ Routing.routeObject.formAction }}" onSuccessRedirect="/surveys"]
            .create-form-body
              <CreateFieldInput label="Name" name="name" placeholder="e.g. Customer feedback" hint="A clear name to identify this survey.">
              <CreateFieldTextarea label="Description (optional)" name="description" placeholder="What would you like to learn?" hint="Add context for other administrators." required="false" rows="5">
            <CreateFormActions submitLabel="Create" cancelHref="/surveys">
          <CreateNextSteps items="{{ Routing.routeObject.nextSteps }}">
  `;
}
